import React, { useState, useRef } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Button,
  Collapse,
  ListItem,
  makeStyles
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
// import useMenu from 'src/hooks/useMenu';
import { useSelector, useDispatch } from 'src/store';
import { updateMenu } from 'src/slices/menu';


const useStyles = makeStyles((theme) => ({
  item: {
    display: 'block',
    paddingTop: 0,
    paddingBottom: 0,
  },

  itemLeaf: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: theme.palette.text.secondary,
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
  },
  buttonLeaf: {
    // color: theme.palette.text.secondary,
    color: 'rgba(24, 24, 25, 0.6)',
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightLight,
    '&.depth-0': {
      '& $title': {
        fontWeight: 500,
        color: 'rgba(24, 24, 25, 0.6)',
      },
    }
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  },
  title: {
    fontFamily: "Roboto",
    fontStyle:"normal",
    // fontWeight: 400,
    fontSize: "14px",
    color: "rgba(24, 24, 25, 0.6)",
    lineHeight: "19.6px",
    marginRight: 'auto',
    '&:hover': {
      color: "rgba(24, 24, 25, 0.6)",
    }
  },
  active: {
    backgroundColor: "#28439D",
    '&.depth-0': {
      '& $title': {
        color: "#ffffff",
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
    '& $title': {
      fontWeight: 500,
      color: "#ffffff",
    },
    '& $icon': {
      color: "#00A8F0"
    },
    '&:hover': {
      backgroundColor: "#28439D",
    }
  }
}));


const NavItem = ({
  children,
  className,
  depth,
  href,
  icon: Icon,
  info: Info,
  open: openProp,
  title,
  currentFarm,
  ...rest
}) => {
  const classes = useStyles();
  const farm = useSelector((state) => state.farm.value);
  const menu = useSelector((state) => state.menu.value);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(openProp);
  const [values, setValues] = useState({
    selectedMenu: menu.selectedMenu,
  });
  // console.log('NavItem :' + farm.selectedFarm);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleSave = (event) => {
    let newMenu = { selectedMenu: event.target.innerHTML};
    dispatch(updateMenu(newMenu));
  };

  let paddingLeft = 8;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }

  const style = { paddingLeft };

  if (children) {
    return (
      <ListItem
        className={clsx(classes.item, className)}
        disableGutters
        key={title}
        {...rest}
      >
        <Button
          className={classes.button}
          onClick={handleToggle}
          style={style}
        >
          {Icon && (
            <Icon
              className={classes.icon}
              size="20"
            />
          )}
          {/* <span className={classes.title}> */}
            {title}
          {/* </span> */}
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Button>
        <Collapse in={open}>
          {children}
        </Collapse>
      </ListItem>
    );
  }

  return (
    <ListItem
      className={clsx(classes.itemLeaf, className)}
      disableGutters
      key={title}
      value={title}
      // onClick={(event) => console.log(event.target.value)}
      {...rest}
    >
      <Button
        activeClassName={classes.active}
        className={clsx(classes.buttonLeaf, `depth-${depth}`)}
        component={RouterLink}
        exact
        style={style}
        to={href}
        title={title}
        onClick={(event) => handleSave(event)} // 메뉴를 클릭할때마다 state 값을 업데이트 한다.
        // onClick={(event) => console.log(event.target.value)}
      >
        {Icon && (
          <Icon
            className={classes.icon}
            size="20"
          />
        )}
        <span className={classes.title}>
          {title}
        </span>
        {Info && <Info />}
      </Button>
    </ListItem>
  );
};

NavItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  info: PropTypes.elementType,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
  changeMenu: PropTypes.func
};

NavItem.defaultProps = {
  open: false,
};

export default NavItem;
